import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SamplesList({ samples }) {
  const { t } = useTranslation();

  // Funzione per tradurre lo stato
  const translateStatus = (status) => {
    if (!status) return '-';

    switch (status.toLowerCase()) {
      case 'sent':
        return t('Inviato');
      case 'draft':
        return t('In Bozza');
      default:
        return status; 
    }
  };

  // Funzione per formattare la data
  const formatDate = (dateString) => {
    if (!dateString) return '-';

    try {
      // Se è già in formato dd-mm-yyyy (varchar), restituiscilo così com'è
      if (dateString.includes('-') && dateString.length === 10) {
        const parts = dateString.split('-');
        // Se è yyyy-mm-dd, convertilo in dd-mm-yyyy
        if (parts[0].length === 4) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        // Se è già dd-mm-yyyy, restituiscilo così
        return dateString;
      }

      // Se è un timestamp (created_at), parsalo e formattalo
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Se non è una data valida, restituisci il valore originale

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString; // In caso di errore, restituisci il valore originale
    }
  };

  return (
    <div className="content_data" id="samples-table">
      <div className="order_table_header">
        <div className="order_table_row">
          <div className="order_table_title sku">{t('Numero Ordine')}</div>
          <div className="order_table_title stato">{t('Stato')}</div>
          <div className="order_table_title data">{t('Data')}</div>
          <div className="order_table_title email">{t('Email')}</div>
          <div className="order_table_title telefono">{t('Telefono')}</div>
          <div className="order_table_title note">{t('Note')}</div>
        </div>
      </div>
      <div className="order_table_body">
        {samples.length === 0 ? (
          <div className="no-data">{t('Nessuna campionatura disponibile')}</div>
        ) : (
          samples.map((s, idx) => (
            <div key={s?.id ?? idx} className="order_table_row">
              <div className="order_table_title sku" data-label={t('Numero Ordine')}>
                {s?.OrderIdAX ?? '-'}
              </div>
              <div className="order_table_title stato" data-label={t('Stato')}>
                <span className={`status-badge ${(s?.StatoOrdine ?? '').toLowerCase()}`}>
                  {translateStatus(s?.StatoOrdine)}
                </span>
              </div>
              <div className="order_table_title data" data-label={t('Data')}>
                {formatDate(s?.DataOrdine ?? s?.created_at)}
              </div>
              <div className="order_table_title email" data-label={t('Email')}>
                {s?.EmailCampionatura ?? '-'}
              </div>
              <div className="order_table_title telefono" data-label={t('Telefono')}>
                {s?.TelefonoCampionatura ?? '-'}
              </div>
              <div className="order_table_title note" data-label={t('Note')}>
                {s?.NoteOrdine ?? '-'}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}